<template>
    <div class="section-post-creator">
        <header>
            <div class="container-title">
                <div class="btn-back" v-if="!isDemo" @click="goBackToPlanner();"></div>
                <div class="text">
                    <h2 class="title">{{title}}</h2>
                    <!-- <p class="switchOldVersion" @click="assignUsers">Assigner pour validation{{ idUsersAssigned.length ? `(${idUsersAssigned.length})` : '' }}</p> -->
                    <p v-if="!previewMode.active && ['create','duplicate'].includes(mode) && canRestoreDraft" class="switchOldVersion" @click="$emit('retoreDraftInLocalStorage')">{{ $t('dash.post-creator.action.restore-draft') }}</p>
                    <p v-else-if="mode !== 'create'" class="switchOldVersion" @click="goBackToPlanner();">{{ $t('dash.post-creator.back-to-planner') }}</p>
                </div>
            </div>

            <div class="btns-action">
               
                <template v-if="!previewMode.active">

                    <template  v-if="formData.planifiedDate.date" >
                        <div v-if="isCurrentUserAssigned" class="btn assign" @click="unassignCurrentUser">
                            {{ $t('dash.post-creator.user.unassign') }}
                            <i class="fa-solid fa-user-minus"></i>
                        </div>
                        <div v-else class="btn assign" @click="assignUsers">
                            {{ $t('dash.post-creator.user.assign') }} {{ idUsersAssigned.length ? `(${idUsersAssigned.length})` : '' }}
                        <i class="fa-solid fa-user-plus"></i>
                    </div>
                    </template>
                    
                    <Tooltip
                        :text="$t('dash.post-creator.media.uploading')"
                        :active="isFileUploading"
                        position="bottom"
                    >
                        <div class="btn-outline-primary" v-if="mode !== 'update' && !(formData.planifiedDate.date && idUsersAssigned.length && requiredValidation)" :class="{disable: isFileUploading || isSavingDraft || !pagesSelected.length}" @click="!isSavingDraft && pagesSelected.length && saveDraft()">{{ isMongoDraftEdit ? $t('dash.post-creator.action.save') : { create: $t('dash.post-creator.action.save-draft'), duplicate: $t('dash.post-creator.action.save-draft'), edit: $t('dash.post-creator.action.convert-to-draft'), draft: $t('dash.post-creator.action.save') }[mode || 'create'] }}</div>
                    </Tooltip>
                    <Tooltip
                        :text="uploadBlockedTooltipText"
                        :active="isFileUploading || hasFailedUpload"
                        position="bottom"
                    >
                        <div
                            class="btn-secondary icon-r"
                            :class="{disable : isFileUploading || hasFailedUpload || !pagesValidForPreview.length}"
                            @click="()=>handlerChangePreviewDisplay(true)">
                            {{ textSwitchPreview }}
                            <i class="fa-solid fa-arrow-right"></i>
                        </div>
                    </Tooltip>
                </template>

                <template v-else>
                    <div class="btn-outline-primary" @click="()=>handlerChangePreviewDisplay(false)">{{ $t('dash.button.go_back') }}</div>
                    <div class="btn-secondary icon-r" :class="{disable : isFileUploading || hasFailedUpload || !pagesValidForPreview.length}" @click="sendPostAllPost">{{textBtnFinish}}<i class="fa-solid fa-arrow-right"></i></div>
                </template>
                
            
            </div>
        </header>
        <div :class="'post-creator '+formShow" ref="postCreator" >
            <div class="container-form" v-if="formShow == 'formMultiple'">
                <div class="nav-type-post">
                    <div class="icon-l" @click.stop="switchTab"><i class="fa-solid fa-pen-to-square"></i>Standard</div>
                    <div v-if="tab == 'story_share'" class="icon-l btn-primary"><i class="fa-solid fa-share-from-square"></i>Partage en story</div>
                    <div v-else class="icon-l" :class="{['btn-primary'] : tab == 'story'}"><i class="fa-solid fa-camera-retro"></i>Story</div>
                </div>

                <div class="container-form-scroll hide-scrollbar">
                    <div class="form">
                        <div class="list-pages-selected hide-scrollbar">
                            <div v-if="tab == 'story' && !pagesSelected.length" class="btn-add-page" @click="openSelectPage">
                                <i class="fa-solid fa-plus"></i>
                                <p>{{ $t('dash.post-creator.pages.add') }}</p>
                            </div>
                            <template v-else >
                                <div class="btn-all-container" v-if="pagesSelected.length > 1 ">
                                    <div class="btn-all unselectable-all " :class="{checked: !idPageSelected}" @click="selectPage(null)">
                                        <i class="fa-solid fa-users"></i>
                                        <p>Tous</p>
                                    </div> 
                                </div>
                                <div class="container-list-avatars hide-scrollbar">
                                    <div class="list-avatars hide-scrollbar">
                                        <Tooltip 
                                            v-for="page in (tab == 'story_share' ? pagesInstagramActivedShareStory : pagesSelected)" 
                                            :text="page.name"
                                            :key="page.id"
                                        >
                                            <Avatar 
                                                :urlPicture="page.avatar" 
                                                :typeNetwork="page.network" 
                                                :checked="page.id == idPageSelected"
                                                :edited="pagesSelected.length > 1 ? tab == 'story_share' ? saveAllFormData.pages[page.id] && Object.hasOwn(saveAllFormData.pages[page.id], 'storification') : saveAllFormData.pages[page.id] && Object.keys(saveAllFormData.pages[page.id]).length > 0 : false"
                                                @click="()=> selectPage(page)"
                                            />
                                        </Tooltip>
                                    </div>
                                </div>
                            </template>
                            
                        </div>          
                        <FormStoryFacebook
                            v-if="currentNetwork === 'facebook'"
                            :formData="formData"
                            :idStorySelected="idStorySelected"
                            :pageSelected="currentPage"
                            :files="files"
                            @addFile="(...args)=>this.$emit('addFile',...args)"
                            @retryUploadFile="(...args)=>this.$emit('retryUploadFile',...args)"
                            @discardFailedFile="(...args)=>this.$emit('discardFailedFile',...args)"
                            @saveFormData="saveFormData"
                            >
                        </FormStoryFacebook>
                        <FormStory
                            v-else
                            ref="formStory"
                            :formData="formData"
                            :updateFormData="pagesSelected.length > 1 && idPageSelected && saveAllFormData.pages[idPageSelected] && saveAllFormData.main.storification[idStorySelected]  ? saveAllFormData.pages[idPageSelected] : {}"
                            :idStorySelected="idStorySelected"
                            :files="files"
                            :tab="tab"
                            :mediaEditorData="mediaEditorData"
                            @addFile="(...args)=>this.$emit('addFile',...args)"
                            @retryUploadFile="(...args)=>this.$emit('retryUploadFile',...args)"
                            @discardFailedFile="(...args)=>this.$emit('discardFailedFile',...args)"
                            @saveFormData="saveFormData"
                            @restoreFormData="restoreFormData"
                            @startEditVideoBackground="startEditVideoBackground"
                            @startEditImageBackground="startEditImageBackground"
                            >
                        </FormStory>
                    </div>
                </div>
            </div>
            
            <div class="container-phone" ref="containerPhone">
                <div :class="`nav-stories left`" v-if="tab !== 'story_share'">
                    <div class="list-stories">
                        <draggable 
                            class="list-stories-draggable" 
                            ref="listMedia" 
                            v-model="idsStories" 
                            :animation="200"
                            group="description"
                            :disabled="false",
                            ghostClass="ghost"
                            :filter="'.lockdrag'"

                        >
                            <transition-group type="transition" :name="'flip-list'">
                                <div class="item" 
                                    v-for="(id, index) in idsStories" 
                                    :class="{
                                        active: idStorySelected == id, 
                                        disable : formData.storification[id].hide,
                                        lockdrag: true || idStorySelected !== id
                                    }" 
                                    @click="selectStory(id)"
                                    :key="id"
                
                                    >

                                    {{index+1}}
                                    <Tooltip v-if="pagesSelected.length > 1 && !previewMode.active && saveAllFormData.main && saveAllFormData.main.storification && !saveAllFormData.main.storification[id]" :text="$t('dash.post-creator.story.page-specific')" position="right" :classCustom="'icon-edited'"></Tooltip>
                                </div>
                            </transition-group>
                        </draggable>
                        
                        <div class="item" @click="addNewStory" v-if="Object.keys(formData.storification).length < 10 && !previewMode.active">
                            <i class="fa-solid fa-plus"></i>
                        </div>
                    </div>
                </div>

                <!-- switch entre post standard ou parte en story dans la preview -->
                <div class="switch-preview-post-type" v-if="previewMode.active && tab == 'story_share'">
                    <div class="" @click.stop="()=>$emit('changeTab','standard')">Standard</div>
                    <div class="btn-primary">Story</div>
                </div>

                <Phone :firstPlan="phoneIsFirstPlan" :showNotch="false" currentScopeKey="story">
                    <StoryMakerFacebook
                        v-if="currentNetwork === 'facebook'"
                        :formData="formData"
                        :idStorySelected="idStorySelected"
                        :deleteStory="deleteStory"
                        :pageSelected="currentPage"
                        :previewEnabled="previewMode.active"
                        :files="files"
                        @saveFormData="saveFormData"
                    />
                    <StoryMaker
                        v-else
                        :formData="formData"
                        :saveAllFormData="saveAllFormData"
                        :idStorySelected="idStorySelected"
                        :deleteStory="deleteStory"
                        :toggleHideStory="toggleHideStory"
                        :pageSelected="currentPage"
                        :previewEnabled="previewMode.active"
                        :files="files"
                        @saveFormData="saveFormData"
                    />

                    <selectMention v-if="modes.includes('addMentionMode')"
                        @close="removeMode"
                        :position="'left'"
                        :networks="[currentNetwork]"
                        :mentionData="dataMode.addMentionMode && dataMode.addMentionMode.mention ? dataMode.addMentionMode.mention : {}"
                        :idMention="dataMode.addMentionMode && dataMode.addMentionMode.idMention ? dataMode.addMentionMode.idMention : null"
                    />
                </Phone>
                <template v-if="previewMode.active">
                    <div class="nav-page-standard" v-if="tab == 'story_share'">
                        <div class="list-page hide-scrollbar">
                            <template v-for="(networkName, index) in listNetworkSort">
                                <div class="group" v-if="pagesSelected.some(p => p.network == networkName)" :key="networkName" :class="{'active': false}">
                                    <div class="network" 
                                        :class="{
                                            [networkName]:true, 
                                            edited: saveAllFormData.networks[networkName] && Object.keys(saveAllFormData.networks[networkName]).length > 0,
                                            failed: previewMode.active && pagesSelected.some(page => page.network == networkName && dataFormRequest[page.id] &&  dataFormRequest[page.id].error)
                                        }" 
                                    >
                                    </div>
                                    <div class="list-avatar">
                                       
                                        <div class="container-avatar"
                                            v-for="page in pagesSelected.filter(p => p.network == networkName)" 
                                            :class="{
                                                checked: (previewMode.pageSelected && previewMode.pageSelected.id == page.id), 
                                            }"
                                            :key="page.id"
                                        >
                                          
                                            <Avatar 
                                                @click="()=>{
                                                    $emit('changePreviewDisplay',true, page);
                                                    $emit('generateFormData',page)
                                                }" 
                                                :checkIsPossible="true" 
                                                :checked="(previewMode.pageSelected && previewMode.pageSelected.id == page.id)" 
                                                :urlPicture="page.avatar"

                                            />
                                        </div>
                                    </div>
                                </div>   
                            </template>  
                        </div>
                    </div>

                    <div v-else class="nav-page-story hide-scrollbar">
                        <Avatar 
                            v-for="(page, index) in pagesValidForPreview" 
                            :urlPicture="page.avatar" 
                            :typeNetwork="page.network" 
                            :key="page.id+index" 
                            :checked="previewMode.pageSelected && page.id == previewMode.pageSelected.id"
                            @click="()=>{
                                $emit('changePreviewDisplay',true, page);
                                $emit('generateFormData', page)
                            }" 
                        />
                    </div>    
                </template>
                
            </div>
        </div>

        <portal to="media-editor-dash" v-if="mediaEditorData.fileIdOrigin && files[mediaEditorData.fileIdOrigin] && files[mediaEditorData.fileIdOrigin].url">
            <transition name="fade">
                <MediaEditor
                    key="media-editor-story"
                    :videoSrc="files[mediaEditorData.fileIdOrigin].url"
                    :localFile="files[mediaEditorData.fileIdOrigin].localFile"
                    :timelineState="mediaEditorData.timelineState ? JSON.parse(mediaEditorData.timelineState) : null"
                    :extraFiles="mediaEditorData.extraFiles"
                    :networksSelected="['instagram']"
                    :originSourceType="files[mediaEditorData.fileIdOrigin] ? files[mediaEditorData.fileIdOrigin].info.type2 : 'video'"
                    :originIsGif="files[mediaEditorData.fileIdOrigin] ? files[mediaEditorData.fileIdOrigin].info.type === 'image/gif' : false"
                    scopeKey="story"
                    @finished="endEditMedia"
                    @export-start="onExportStart"
                    @export-progress="onExportProgress"
                    @export-failed="onExportFailed"
                    @clickOutside="mediaEditorData.fileIdOrigin = null"
                />
            </transition>
        </portal>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import store from '@/store/index.js';
import ComponentSwitch from '@/components/dash/utils/switch.vue';
import Avatar from '../utils/avatar.vue';
import Checkbox from '@/components/dash/utils/checkbox.vue';
import Phone from './components/Phone.vue';
import FormStory from './components/storyTab/FormStory.vue';
import StoryMaker from './components/storyTab/StoryMaker.vue';
import FormStoryFacebook from './components/storyTab/FormStoryFacebook.vue';
import StoryMakerFacebook from './components/storyTab/StoryMakerFacebook.vue';
import selectMention from './components/formOverlay/selectMention.vue'
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'
import draggable from 'vuedraggable'
import { lazyComponent } from '@/utils/appVersion'
// Lazy-loaded: pulls in fabric.js + mediabunny, only needed once someone actually edits a video
// background - see startEditVideoBackground/mediaEditorData below. Lives here (not FormStory.vue)
// so the export session survives switching to the preview screen, where "Valider" is clicked -
// see the formShow/previewMode.active watcher below, which destroys FormStory.vue's whole subtree.
const MediaEditor = lazyComponent(() => import('@/components/dash/mediaEditor/MediaEditor.vue'));

import { formDataDefault, maxFilesPerNetwork, listNetworkSort } from './constante.js'
import SSE from './../../../utils/sse.js'

import postMixin from '@/components/mixins/Posts.vue'
import draftMixin from '@/components/mixins/Drafts.vue'
import {
    foreachSaveAllFormData,
    customModeIsAvailable as customModeIsAvailableUtil,
    getPlanifiedDateISO
 } from './utils.js';


export default {
    components: {
        ComponentSwitch,
        Phone,
        FormStory,
        StoryMaker,
        FormStoryFacebook,
        StoryMakerFacebook,
        Avatar,
        Checkbox,
        selectMention,
        Tooltip,
        draggable,
        MediaEditor
    },
    mixins: [postMixin, draftMixin],

    props: {
        mode: String,
        tab: String,
        files:Object,
        isFileUploading:Boolean,
        hasFailedUpload: Boolean,
        isSavingDraft: Boolean,
        formData: Object,
        saveAllFormData: Object,
        dataFormRequest: Object,
        previewMode: Object,
        idUsersAssigned: {
            type:Array,
            default: ()=>[]
        },
        requiredValidation:Boolean,
        canRestoreDraft:Boolean,
        isMongoDraftEdit: { type: Boolean, default: false },
    },

    data() {
        return {
           
            listNetworkSort: listNetworkSort,
           

            formShow: "formMultiple",// pour l'annimation
            timeOutAnnimateForm: null,

            idStorySelected: "0",
            idPageSelected: null,

            // Lives here (not FormStory.vue) so an export in progress survives the formShow/
            // previewMode.active toggle above, which destroys FormStory.vue's whole subtree -
            // "Valider" (sendPostAllPost) is only clickable once previewMode.active is true, so a
            // session tracked on FormStory.vue itself would always look empty at that exact moment.
            mediaEditorData: {
                fileIdOrigin: null,
                fileId: null,
                // idStorySelected captured at the moment "Créer une vidéo" is clicked - a long
                // export can outlive the user switching to a *different* story slide, and
                // this.idStorySelected read fresh at completion could then point at the wrong
                // slide. Always use this captured value instead, anywhere in the export lifecycle.
                storyId: null,
                timelineState: null,
                extraFiles: {},
                exporting: false,
                exportProgress: 0,
                // Carried by mediaExportJobs.js's job - lets a submit click (see
                // getPendingMediaExportSessionsInfo/claimMediaExportJobIds below) find and claim
                // exactly the job backing whatever's still exporting right now, mirroring
                // StandardTab.vue's own session.jobId.
                jobId: null
            },
            // jobId -> true for a job claimed by a pending publish (see PostCreator.vue's
            // sendPostAllPost/claimMediaExportJobIds) - endEditMedia/onExportFailed become no-ops
            // for a claimed job, same reasoning as StandardTab.vue's own claimedMediaJobIds.
            claimedMediaJobIds: {},

            //la list mode est connu et modifiable par tout les interfaces Network et les deux formulaires
            modes : [],
            dataMode : {},

            dataFormRequest : {},
            showTutorial : !localStorage.postCreatorCountUseSelectorMode ? true : localStorage.postCreatorCountUseSelectorMode < 3,
            pagesInstagramActivedShareStory: [],
            idsStories: []
        }
    },



    created() {
        EventBus.$on('postCreatorAddMode', this.addMode);
        EventBus.$on('postCreatorRemoveMode', this.removeMode);

        if (this.tab == 'story_share') {
            this.setPagesInstagramActivedShareStory()
        }
    },


    methods: {
        isProd() {
            return process.env.VUE_APP_API_HOST === 'https://api.saas.mashup-web.com'
        },

        ///////////// METHOD NAVIGATION /////////////

        goBackToPlanner() {
            if (this.isDemo) return // /dash/posts2 requires a real session - would bounce to signup
            this.$router.push({ name: 'posts2', params: { date: getPlanifiedDateISO(this.formData.planifiedDate), scrollToHour: true } })
        },

        switchTab() {
            this.saveFormData()
            this.$emit("generateFormData")
            this.$emit("changeTab",'standard')
        },

        selectPage(page = null) {
            if (page) {
                if(!this.idPageSelected)  this.$emit("saveFormData")
                this.idPageSelected = page.id
                this.$emit("generateFormData",page)
            }else{
                this.idPageSelected = null
                this.$emit("generateFormData")
            }

            //Calcul "idStorySelected" pour savoir quelle aperçu de story afficher
            if (!this.formData.storification[this.idStorySelected] || this.formData.storification[this.idStorySelected].hide) {
                const idsStories = Object.keys(this.formData.storification).sort((a, b) => parseInt(a) > parseInt(b))
                this.idStorySelected = idsStories.find(id => !this.formData.storification[id].hide) || idsStories[0]
            }
        },

        async handlerChangePreviewDisplay(state) {
            if (state) {
                const page = this.pagesSelected.find(page => (page.network == 'instagram' || page.network == 'facebook') && (!this.idPageSelected || page.id == this.idPageSelected))
                if (page && !this.isFileUploading) {
                    EventBus.$emit('storyMaker-confirmEditingSticker');
                    await this.$nextTick();
                    this.$emit('changePreviewDisplay', true, page)
                    this.$emit('generateFormData', page)
                }
            }else{
                this.$emit('changePreviewDisplay', false)
                this.selectPage(this.idPageSelected ? this.pagesSelected.find(page => page.id == this.idPageSelected) : null)
            }

        },

        selectStory(id) {
            if (!this.formData.storification[id]) return
            this.idStorySelected = id
        },

        addMode(mode, data = {}) {
            if (!this.modes.includes(mode)) this.modes = [...this.modes,mode]
            this.$set(this.dataMode, mode, data)
        },

        removeMode(mode = 'all') {
            if (mode == 'all') {
                this.modes = []
                return
            }
            this.modes = this.modes.filter(v => v !== mode)
        },

        switchInterface() {
            localStorage.setItem('postCreatorInterfacePreference', 'old')
            this.$router.push({
                name: 'planner',
                params: {
                newPost: true
                }
            })
        },

        openSelectPage() {
            this.$store.commit('selectPage/updateSelectPageListRetracted', false)
        },

        ///////////// METHOD STORY /////////////

        addNewStory() {
            if (this.formData.storification.length >= 10) return
            // const idStory = (Date.now()+(this.formShow == 'formUnique' ? 10000000 : 0)).toString()
            const idStory = Date.now().toString()
            const story = JSON.parse(JSON.stringify(formDataDefault.storification['0']))
            console.log("storyadd",story)
            this.$set(this.formData.storification, idStory,
                story
            )
            this.idStorySelected = idStory
            this.saveFormData()
        },

        deleteStory(id = undefined) {
            if (id === undefined)  id = this.idStorySelected
            const ids = Object.keys(this.formData.storification).sort()
            if(this.formData.storification[id] && ids.length > 1) {
                this.$delete(this.formData.storification, id)
                this.idStorySelected = ids.filter(v => v !== id)[Math.max(0,ids.findIndex(v => v == id)-1)]
            }
            this.saveFormData()
        },

        toggleHideStory(id = undefined) {
            if (id === undefined)  id = this.idStorySelected
            const ids = Object.keys(this.formData.storification).sort()
            const value = !this.formData.storification[id].hide ? true : false
            this.$set(this.formData.storification[id],'hide', value)
            if (value) this.idStorySelected = ids[Math.max(ids.findIndex((k) => !this.formData.storification[k].hide), 0)]
            this.saveFormData()
        },

        storyMoving() {
            
            const index = this.idsStories.findIndex(id => id == this.idStorySelected)
            let newId = null

            if (index == 0) {
                newId = parseInt(this.idsStories[1])/2
            }else if (index == this.idsStories.length -1) {
                newId = parseInt(this.idsStories[this.idsStories.length - 2]) + 10000000
            }else{
                newId = parseInt(this.idsStories[index - 1]) + ((parseInt(this.idsStories[index + 1]) - parseInt(this.idsStories[index - 1]))/2)
            }

            newId = Math.round(newId).toString()
            console.log("storyMoving", newId, this.idStorySelected)

            this.$set(this.formData.storification, newId,
                this.formData.storification[this.idStorySelected]
            )
            this.$delete(this.formData.storification, this.idStorySelected)
            this.sortStoriesId()


            foreachSaveAllFormData(this.saveAllFormData, (formData) => {
                if (formData.storification && formData.storification[this.idStorySelected]) {
                    formData.storification[newId] = formData.storification[this.idStorySelected]
                    delete formData.storification[this.idStorySelected]
                }
            })

         
            this.idStorySelected = newId
            this.saveFormData()
        },

        sortStoriesId() {
            this.idsStories = Object.keys(this.formData.storification).sort((a, b) => parseInt(a) > parseInt(b)) || []
        },

        //////////// METHOD FOR FORMDATA ////////////

        restoreFormData(path) {     
            console.log("restoreFormData", path, this.idPageSelected, this.saveAllFormData.pages[this.idPageSelected])
            if(this.idPageSelected && this.saveAllFormData.pages[this.idPageSelected]){
                this.$emit("restoreFormData", path, this.pagesSelected.find(page => page.id == this.idPageSelected) || this.allPages[this.idPageSelected] )
            }
        },

        saveFormData() {
            this.$emit("saveFormData", this.idPageSelected ? 
                this.pagesSelected.find(page => page.id == this.idPageSelected) || this.allPages[this.idPageSelected]
                : null
            )
        },

        unassignCurrentUser() {
            this.$emit('unassignCurrentUser')
        },

        assignUsers() {
            this.$emit('assignUsers')
        },

        setPagesInstagramActivedShareStory() {

            const customModeIsAvailable = customModeIsAvailableUtil({
                pagesSelected: this.pagesSelected,
                validator: null,
                formDataMain: this.saveAllFormData.main,
                files: this.files,
            })


            console.log("setPagesInstagramActivedShareStory", this.formData.formDataNetwork.instagram.storification.active)
            let defaultActivedShareStory = this.saveAllFormData.main.formDataNetwork.instagram.storification.active

            //regarde si la valeur de storification dans la customisation de instagram
            let saveNetworkIsActiveStory = null

            if (
                customModeIsAvailable &&
                this.saveAllFormData.networks &&
                this.saveAllFormData.networks['instagram'] && 
                this.saveAllFormData.networks['instagram'].formDataNetwork &&
                this.saveAllFormData.networks['instagram'].formDataNetwork.instagram &&
                this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.storification &&
                this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.storification.hasOwnProperty('active')
            ) {
                saveNetworkIsActiveStory =  this.saveAllFormData.networks['instagram'].formDataNetwork.instagram.storification.active
            }
 
            this.pagesInstagramActivedShareStory = this.pagesSelected.filter(page => {
                if (page.network !== 'instagram') return false
                //verif conciergerie
                if (!page.story_config || !page.story_config.created) return false

                if (
                    customModeIsAvailable &&
                    this.saveAllFormData.pages?.[page.id]?.formDataNetwork?.instagram?.storification?.hasOwnProperty('active')
                ) {
                    return  this.saveAllFormData.pages[page.id].formDataNetwork.instagram.storification.active
                }
              
                if (saveNetworkIsActiveStory !== null) {
                    return  saveNetworkIsActiveStory
                }
                return defaultActivedShareStory
            })

            if (this.pagesInstagramActivedShareStory.length == 0 && this.tab == 'story_share') {
               this.switchTab()
            }

        
        },

        saveDraft() {
            if (this.isFileUploading || this.isSavingDraft) return
            EventBus.$emit('storyMaker-confirmEditingSticker');
            this.$nextTick(() => {
                this.saveFormData()
                this.$emit('saveDraft')
            })
        },

        sendPostAllPost() {
            if (this.isFileUploading || this.hasFailedUpload) return
            this.$emit('sendPostAllPost')
        },

        // Opens the video editor on the story's current video background - the image case
        // (openBackgroundResizeMode, in FormStory.vue) keeps its own separate resize/position
        // overlay, untouched. Triggered by FormStory.vue's @startEditVideoBackground emit.
        startEditVideoBackground(fileId) {
            if (this.mediaEditorData.exporting) return
            if (!fileId || !this.files[fileId] || !this.files[fileId].url) return

            this.mediaEditorData.storyId = this.idStorySelected
            this.mediaEditorData.fileId = fileId
            this.mediaEditorData.timelineState = null
            this.mediaEditorData.extraFiles = {}

            const background = this.formData.storification[this.idStorySelected].background
            if (background.file.mediaEditorData && background.file.mediaEditorData.fileIdOrigin && this.files[background.file.mediaEditorData.fileIdOrigin]) {
                this.mediaEditorData.timelineState = background.file.mediaEditorData.timelineState || null
                this.mediaEditorData.extraFiles = background.file.mediaEditorData.extraFiles || {}
                this.mediaEditorData.fileIdOrigin = background.file.mediaEditorData.fileIdOrigin
            } else {
                this.mediaEditorData.fileIdOrigin = fileId
            }
        },

        // Mirrors startEditVideoBackground above, for the image case (FormStory.vue's edit-icon
        // on the picture thumbnail) - opens the full MediaEditor in photo mode (documentMode
        // resolves from originSourceType, see the <MediaEditor> binding above) instead of the
        // simpler position/resize overlay (openBackgroundResizeMode, FormStory.vue - still
        // triggered by clicking the thumbnail itself, untouched).
        startEditImageBackground(fileId) {
            if (this.mediaEditorData.exporting) return
            if (!fileId || !this.files[fileId] || !this.files[fileId].url) return

            this.mediaEditorData.storyId = this.idStorySelected
            this.mediaEditorData.fileId = fileId
            this.mediaEditorData.timelineState = null
            this.mediaEditorData.extraFiles = {}

            const background = this.formData.storification[this.idStorySelected].background
            if (background.file.mediaEditorData && background.file.mediaEditorData.fileIdOrigin && this.files[background.file.mediaEditorData.fileIdOrigin]) {
                this.mediaEditorData.timelineState = background.file.mediaEditorData.timelineState || null
                this.mediaEditorData.extraFiles = background.file.mediaEditorData.extraFiles || {}
                this.mediaEditorData.fileIdOrigin = background.file.mediaEditorData.fileIdOrigin
            } else {
                this.mediaEditorData.fileIdOrigin = fileId
            }
        },

        endEditMedia(event) {
            // Claimed by a pending publish (see PostCreator.vue's sendPostAllPost/
            // claimMediaExportJobIds) - that deferred-publish path exclusively owns applying this
            // job's result once it resolves, so this is a pure no-op here (mirrors StandardTab.vue's
            // endEditMedia).
            const jobId = this.mediaEditorData.jobId || event.jobId
            if (jobId && this.claimedMediaJobIds[jobId]) return

            const timelineStateString = JSON.stringify(event.timelineState)
            const file = event.file
            const extraFiles = event.extraFiles || {}
            const id = Math.random().toString(36).substr(2, 9)
            const storyId = this.mediaEditorData.storyId

            this.$emit('addFile', null, file, true, id, () => {
                // Any exception thrown in this callback propagates straight into PostCreator.vue's
                // uploadFile, which swallows it in its own top-level try/catch (Sentry-logged only) -
                // without a try/finally here, that would skip resetting mediaEditorData.exporting and
                // leave the loader on the story background stuck forever (see the equivalent fix in
                // StandardTab.vue's endEditMedia).
                try {
                    if (this.files[id] && this.formData.storification[storyId]) {
                        this.$set(this.formData.storification[storyId].background, 'file', {
                            id,
                            mediaEditorData: {
                                fileIdOrigin: this.mediaEditorData.fileIdOrigin,
                                timelineState: timelineStateString,
                                extraFiles
                            }
                        })
                        this.saveFormData()
                    }
                } catch (e) {
                    console.error('[StoryTab] endEditMedia: failed to apply the exported video to the story background', e)
                } finally {
                    this.mediaEditorData.exporting = false
                    this.mediaEditorData.fileIdOrigin = null
                }
            })
        },

        onExportStart({ timelineState, extraFiles, jobId } = {}) {
            this.mediaEditorData.exporting = true
            this.mediaEditorData.exportProgress = 0
            this.mediaEditorData.jobId = jobId
            // Snapshot of the edit actually being encoded right now (not whatever was there before
            // this "Terminer" click, from startEditVideoBackground's resume values) - so a deferred
            // publish (getPendingMediaExportSessionsInfo, called while this export is still running)
            // persists the CURRENT edit, not stale/null pre-edit data. Mirrors StandardTab.vue's own
            // onExportStart.
            this.mediaEditorData.timelineState = JSON.stringify(timelineState)
            this.mediaEditorData.extraFiles = extraFiles
            try {
                const background = this.formData.storification[this.mediaEditorData.storyId]?.background
                if (background?.file?.mediaEditorData?.exportError) {
                    this.$set(background.file.mediaEditorData, 'exportError', null)
                }
            } catch (e) {
                console.error('[StoryTab] onExportStart: failed to clear the previous export error', e)
            }
        },

        onExportProgress(progress) {
            this.mediaEditorData.exportProgress = progress
        },

        onExportFailed({ error, timelineState, extraFiles, jobId }) {
            // Same claimed-job no-op as endEditMedia above.
            const claimedJobId = this.mediaEditorData.jobId || jobId
            if (claimedJobId && this.claimedMediaJobIds[claimedJobId]) return

            const storyId = this.mediaEditorData.storyId
            try {
                const background = this.formData.storification[storyId]?.background
                if (background && background.file && background.file.id === this.mediaEditorData.fileId) {
                    this.$set(background.file, 'mediaEditorData', {
                        fileIdOrigin: this.mediaEditorData.fileIdOrigin,
                        timelineState: JSON.stringify(timelineState),
                        extraFiles,
                        exportError: error
                    })
                }
            } catch (e) {
                console.error('[StoryTab] onExportFailed: failed to persist the export error', e)
            } finally {
                this.mediaEditorData.exporting = false
                this.mediaEditorData.fileIdOrigin = null
            }
        },

        // Called by PostCreator.vue's sendPostAllPost at submit time - mirrors StandardTab.vue's
        // method of the same name, but against this single flat mediaEditorData object instead of
        // a map (a story only ever has one editing slot at a time - see mediaEditorData's own
        // comment above).
        getPendingMediaExportSessionsInfo() {
            if (!this.mediaEditorData.exporting || !this.mediaEditorData.jobId) return []
            return [{
                jobId: this.mediaEditorData.jobId,
                scopeKey: 'story',
                fileIdOrigin: this.mediaEditorData.fileIdOrigin,
                timelineState: this.mediaEditorData.timelineState,
                extraFiles: this.mediaEditorData.extraFiles,
                // Which story slide this background belongs to - applyBackgroundMediaResult
                // (PostCreator.vue) needs it to patch saveAllFormData.main.storification[storyId],
                // there being no per-scope map here to derive it from otherwise.
                storyId: this.mediaEditorData.storyId
            }]
        },

        // Mirrors StandardTab.vue's method of the same name - endEditMedia/onExportFailed become
        // no-ops for a claimed job (see their own checks above).
        claimMediaExportJobIds(jobIds) {
            jobIds.forEach(jobId => this.$set(this.claimedMediaJobIds, jobId, true))
        },

    },

    computed: {
        currentUser() {
            return this.$store.getters['users/getCurrentUser']
        },

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },

        isDemo() {
            return this.$store.getters['demo/isActive'];
        },

        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]).filter(p => p && (p.network == 'instagram' || (p.network == 'facebook' && p.story_config && p.story_config.created)) && (this.tab !== "story_share" || (p.story_config && p.story_config.created)));
        },

        currentPage() {
            return this.previewMode.active ? this.previewMode.pageSelected : this.pagesSelected.find(p => p.id == this.idPageSelected)
        },

        currentNetwork() {
            if (this.currentPage) return this.currentPage.network
            return this.pagesSelected.length && this.pagesSelected.every(p => p.network === 'facebook') ? 'facebook' : 'instagram'
        },
       
        phoneIsFirstPlan() {
            let validmodes = ['addCollaboratorMode','addIdentifierMode','addPlaceMode', 'addMusicMode','addMentionMode','addHashtagMode']
            return validmodes.find(v => this.modes.includes(v)) ? true : false
        },

        // textContentConverted() {
    
        //     const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
        //     if (!this.formData.textContent || regex.test( this.formData.textContent)) return ''
            
        //     return this.formData.textContent.replaceAll("\\n", '<br>')
        // },

        // textCommentConverted() {
        //     const regex = /^(<br\s*\/?>|\\n|\s*)+$/i
        //     if (!this.formData.comments[0] || regex.test( this.formData.comments[0])) return ''

        //     return this.formData.comments[0] ? this.formData.comments[0].replaceAll("\\n", '<br>') : ''
        // },

        countDataFormRequestValid() {
            return Object.values(this.dataFormRequest).filter(form => !form.hasOwnProperty('error')).length
        },

        isCurrentUserAssigned() {
            return (
                this.formData.planifiedDate.date && 
                this.idUsersAssigned.length && 
                this.requiredValidation && 
                this.idUsersAssigned.includes(this.currentUser.id)
            )
        },
        

        textSwitchPreview() {

            if (this.formData.planifiedDate.date && this.idUsersAssigned.length && this.requiredValidation ) {
                if (this.isCurrentUserAssigned) {
                    return this.$t('dash.post-creator.action.validate')
                }else{
                    return this.$t('dash.post-creator.action.send-for-validation')
                }

            }
            if (this.mode == 'edit' && !this.isMongoDraftEdit) return this.$t('dash.post-creator.action.apply')
            let postPlanified = false
            let postInstantly = false

            const formMain = !this.idPageSelected ? this.formData : this.saveAllFormData.main

            for (let i = 0; i < this.pagesSelected.length; i++) {
                if (postPlanified && postInstantly) break;
                const page = this.pagesSelected[i];

                const formDataByPage = this.idPageSelected  && this.idPageSelected  == page.id ? this.formData : this.saveAllFormData.pages[page.id]


                if (formDataByPage && formDataByPage.planifiedDate) {
                    if (formDataByPage.planifiedDate.date || formDataByPage.planifiedDate.hours) {
                        postPlanified = true
                    }else {
                        postInstantly = true
                    }
                }else{

                    if (formMain.planifiedDate.date || formMain.planifiedDate.hours) {
                        postPlanified = true
                    } else {
                        postInstantly = true
                    }
                }
            }

            if (postPlanified && postInstantly) {
                return this.$t('dash.post-creator.action.publish-and-schedule')
            } else if (postPlanified) {
                return this.$t('dash.button.schedule')
            } else if (postInstantly) {
                return this.$t('dash.post-creator.action.publish')
            }

            return '';
        },

        textBtnFinish() {
            if (this.formData.planifiedDate.date && this.idUsersAssigned.length && this.requiredValidation) {
                if (this.idUsersAssigned.includes(this.currentUser.id)) {
                    return this.$t('dash.post-creator.action.validate')
                }else{
                    return this.$t('dash.post-creator.action.send-for-validation')
                }

            }
            const forms = Object.values(this.dataFormRequest);

            const postPlanified = forms.filter(form => !form.hasOwnProperty('error') && form["data[scheduled_date]"]);
            const postInstantly = forms.filter(form => !form.hasOwnProperty('error') && !form["data[scheduled_date]"]);

            if (postPlanified.length && postInstantly.length) {
                return this.$t('dash.post-creator.action.publish-and-schedule')
            } else if (postPlanified.length) {
                return `${this.$t(postPlanified.length > 1 ? 'dash.post-creator.action.schedule-on-pages' : 'dash.post-creator.action.schedule-on-page', { count: postPlanified.length })}`;
            } else if (postInstantly.length) {
                return `${this.$t(postInstantly.length > 1 ? 'dash.post-creator.action.publish-on-pages' : 'dash.post-creator.action.publish-on-page', { count: postInstantly.length })}`;
            }

            return '';
        },

        uploadBlockedTooltipText() {
            return this.hasFailedUpload
                ? this.$t('dash.post-creator.media.upload-failed')
                : this.$t('dash.post-creator.media.uploading')
        },

        pagesValidForPreview() {
            return this.pagesSelected.filter(page => {
                if (page.network === 'facebook') {
                    const pageForm = this.saveAllFormData.pages[page.id]
                    const allStories = [
                        ...Object.values(this.saveAllFormData.main.storification || {}),
                        ...Object.values((pageForm && pageForm.storification) || {}),
                    ]
                    return allStories.some(story => (story.background && story.background.file) || (story.stickers && Object.keys(story.stickers).length))
                }

                if (!this.saveAllFormData.pages[page.id] || !this.saveAllFormData.pages[page.id].storification) return true

                const amountNewStory = Object.keys(this.saveAllFormData.pages[page.id].storification).filter(idStory => !this.saveAllFormData.main.storification[idStory]).length
                const amountStoryHide =  Object.values(this.saveAllFormData.pages[page.id].storification).filter(story => story.hide).length
                if (Object.keys(this.saveAllFormData.main.storification).length + amountNewStory > amountStoryHide) {
                    const allStories = [
                        ...Object.values(this.saveAllFormData.main.storification),
                        ...Object.values(this.saveAllFormData.pages[page.id].storification),
                    ]
                    if (allStories.some(story => story.stickers && Object.values(story.stickers).some(s => s.type === 'music_missing'))) return false
                    return true
                }
                return false
            })
        },

        title () {

            switch (this.mode) {
                case "edit":
                    return this.$t('dash.post-creator.title.edit-mode')
                case "draft":
                    return this.$t('dash.post-creator.title.draft')

                default:
                    return this.previewMode.active ? this.$t('dash.post-creator.title.preview') : this.$t('dash.post-creator.title.new')

            }


        }
    },

    watch: {

        ["previewMode.active"]: {
            handler(value, oldValue) {
                console.log('watch previewMode.active',value, oldValue)
                if (value) {
                    // if (this.previewMode.pageSelected) this.toggleSelectPageForcustomMode(this.previewMode.pageSelected)
                    if (oldValue == undefined && this.tab == 'story_share') {
                        this.formShow = "preview-right annimate-switch-preview-mode"
                    }else{
                        this.formShow = "preview-right"
                        if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                        this.$nextTick(() => {
                            this.timeOutAnnimateForm = setTimeout(() => {
                                if (this.$refs.postCreator) this.$refs.postCreator.classList.add('annimate-switch-preview-mode');
                            }, 500);
                        })
                    }
                }else{
                    // immediate watcher can fire before this.$refs.postCreator is mounted (same
                    // class of bug as FRONT-SAAS-8 in Editor.vue)
                    if (this.$refs.postCreator) this.$refs.postCreator.classList.remove('annimate-switch-preview-mode');
                    if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                    this.$nextTick(() => {
                        this.timeOutAnnimateForm = setTimeout(() => {
                             this.formShow = "formMultiple"
                        }, 1000);
                    })
                }
            },
            immediate: true
        },
        pagesSelected: {
            handler(pages, oldPages) {
                console.log("watch pagesSelected", {pages, oldPages})
                if (pages.length == 1){
                    if (oldPages == undefined || oldPages.length !== 1) {
                        this.selectPage(pages[0])
                    }
                }else if (pages.length > 1 && oldPages && oldPages.length == 1) {
                    console.log("migratePageSaveInMainSave")
                    this.saveFormData()
                    this.$emit('migratePageSaveInMainSave', oldPages[0].id)
                    this.selectPage()
                }
                if (this.tab == 'story_share') {
                    this.setPagesInstagramActivedShareStory()
                }
            },
            immediate : true
        },
       
        ['formData.storification']: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.sortStoriesId()
                if (this.formData.storification[this.idStorySelected]) return
                this.idStorySelected = Object.keys(this.formData.storification).sort()[0]
            }
        }
        
    },

    beforeDestroy () {
        
        EventBus.$off('postCreatorAddMode', this.addMode);
        EventBus.$off('postCreatorRemoveMode', this.removeMode);
        EventBus.$off('deletePostFromClickSelectPage', this.deletePostFromClickSelectPage);


    }

}
</script>
